import api from '../../../services/api';

const getResponseData = (response, fallback) => response.data ?? fallback;

export const guestService = {
  async getGuests(eventId) {
    const response = await api.get(`/events/${eventId}/guests`);
    return getResponseData(response, []);
  },

  async getMyGuestGroup(eventId) {
    const response = await api.get(`/events/${eventId}/my-guest-group`);
    return getResponseData(response, {});
  },

  async getTestimonials(eventId) {
    const response = await api.get(`/events/${eventId}/testimonials`);
    return getResponseData(response, []);
  },

  async saveTestimonial(eventId, message) {
    const response = await api.post(`/events/${eventId}/testimonials`, { message });
    return getResponseData(response, null);
  },

  async getPhotoWallFeed(eventId) {
    const response = await api.get(`/events/${eventId}/photo-wall/feed`);
    return getResponseData(response, []);
  },

  async togglePhotoWallLike(eventId, photoId) {
    const response = await api.post(`/events/${eventId}/photo-wall/photos/${photoId}/like`);
    return getResponseData(response, {});
  },
};

export default guestService;
